import { useCallback, useRef, useState } from "react";

import api from "api";

export type OmniMentionResult = Record<string, Array<Record<string, unknown>>>;

export type MentionLoader = (
  kind: string[],
  query: string,
) => Promise<OmniMentionResult>;

export const getMentions: MentionLoader = (kind, query) => {
  if (query === "") {
    return Promise.resolve({} as OmniMentionResult);
  }
  return new Promise<OmniMentionResult>((resolve, reject) => {
    api.search.omni(
      {
        query,
        include: kind as (
          | "challenges"
          | "groups"
          | "ideas"
          | "organisations"
          | "users"
          | "tags"
        )[],
        prioritise: true,
      },
      (result) => {
        resolve(result as OmniMentionResult);
      },
      (err) => {
        reject(err);
      },
    );
  });
};

export const useGetMentions = () => {
  const [mentions, setMentions] = useState<OmniMentionResult>({});
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const getScopedMentions = useCallback((kind: string[], query: string) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      getMentions(kind, query)
        .then((result) => {
          setMentions(result);
        })
        .catch(() => {
          setMentions({});
        });
    }, 300);
  }, []);

  return [mentions, getScopedMentions] as const;
};
